/**
 * Filter to transform a String to Pascal Case. It can receive an extra argument to avoid replacing the _ with ' '
 * Considering that var contains the text 'rules_admin':
 * {{var | pascalCase}} will return 'Rules Admin'
 * {{var | pascalCase: false}} will return 'Rules_admin'
 * {{var | pascalCase: true}} will return 'Rules Admin'
 **/
;(function () {
  angular.module('contrast.filters').filter('pascalCase', function () {
    return function (input, skipUnderscoreReplace) {
      input = input || ''
      // Custom name for `org_auditor`
      if (input === 'org_auditor') {
        input = 'auditor'
      }
      if (
        angular.isUndefined(skipUnderscoreReplace) ||
        !skipUnderscoreReplace
      ) {
        input = input.replace('_', ' ')
      }
      return input.replace(/\w\S*/g, function (txt) {
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()
      })
    }
  })
})()
